export enum variantOptions {
  default = "default",
  menu = "menu",
}
